import { z } from 'zod'

import { languages } from '@/features/auth'
import { FormError } from '@/utils/localisation'

import { roles, salutations } from '../domain/user'

export const UpdateUserFormSchema = z.object({
  salutation: z
    .enum(salutations)
    .nullish()
    .transform((data) => data ?? undefined),
  title: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  firstName: z.string(),
  lastName: z.string(),
  phoneLandline: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  phoneMobile: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  languages: z.array(z.enum(languages)),
  roles: z.array(z.enum(roles)),
  organizationId: z.string(),
})

export type UpdateUserFormSchemaType = z.infer<typeof UpdateUserFormSchema>

export const CreateUserFormSchema = z.object({
  salutation: z
    .enum(salutations)
    .nullish()
    .transform((data) => data ?? undefined),
  title: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  phoneLandline: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  phoneMobile: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  languages: z.array(z.enum(languages)),
  email: z.string().email(FormError.EMAIL),
  roles: z.array(z.enum(roles)),
  organizationId: z.string().min(1),
})

export type CreateUserFormSchemaType = z.infer<typeof CreateUserFormSchema>
